import React, { useEffect, useState } from "react";
import jeevesIpVideo from "../assets/videos/askjeevesip.mp4";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import './launchingSoon.css'

const LaunchingSoon = () => {
  const [muted, setMuted] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);


  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000 });
  }, []);
  
  const slides = [
    {
      text: `"The patented optimization tools helped us scale faster than ever while maintaining full legal compliance. Our ROI doubled within the first quarter."`,
      name: "Michael Lee",
      role: "VP Growth, FinTech Solutions",
      img: "https://images.unsplash.com/photo-1535223289827-42f1e9919769",
      companyImg:
        "https://images.unsplash.com/photo-1518770660439-4636190af475",
    },
    {
      text: `"We scaled globally without infrastructure issues. The patented compliance system gave us confidence to expand into new markets while staying protected."`,
      name: "David Clark",
      role: "Product Director, SaaS Cloud Corp",
      img: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
      companyImg:
        "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    },
  ];

  const services = [
    {
      title: "Autonomous AI Smart Replies",
      image: "https://images.unsplash.com/photo-1611605698335-8b1569810432?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-robot",
      hoverIcon: "fas fa-comments",
      frontIcon: "fas fa-robot",
      description:
        "Engage leads instantly with AI that understands intent and guides users toward high-value actions.",
      hoverDescription:
        "Our system goes beyond basic auto-responders to provide personalized, conversational replies that understand user intent and guide them toward high-value actions in real-time.",
      tags: ["AI", "Automation"],
      features: [
        "Intent-based response generation",
        "Personalized conversation flows",
        "High-value action optimization",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },

    {
      title: "Predictive Send-Time Intelligence",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-clock",
      hoverIcon: "fas fa-chart-line",
      frontIcon: "fas fa-clock",
      description:
        "Patented algorithms identify the exact moment your audience is most likely to engage.",
      hoverDescription:
        "Leverage patented algorithms to identify the exact moment your audience is most likely to engage. By predicting optimal delivery windows, we maximize open rates and campaign ROI with precision timing.",
      tags: ["AI", "Optimization"],
      features: [
        "Optimal delivery window prediction",
        "Audience engagement pattern analysis",
        "Maximized open rate optimization",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },

    {
      title: "Dynamic Content Personalization",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-user-cog",
      hoverIcon: "fas fa-magic",
      frontIcon: "fas fa-user-cog",
      description:
        "AI-powered real-time mobile content generation based on individual user behavior.",
      hoverDescription: "Our AI-powered platform generates and delivers mobile content in real-time based on individual user behavior and behavioral pattern analysis, creating hyper-personalized experiences that drive engagement.",
      tags: ["Personalization", "AI"],
      features: [
        "Real-time content generation",
        "Behavioral pattern analysis",
        "Hyper-personalized messaging",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },

    {
      title: "Real-Time TCPA Compliance Guardrails",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-shield-alt",
      hoverIcon: "fas fa-gavel",
      frontIcon: "fas fa-shield-alt",
      description:
        '"Zero-Error" compliance system with automated consent verification.',
      hoverDescription: "Stay protected with a Zero-Error compliance system. Our AI continuously monitors campaigns for TCPA compliance, with automated consent verification and predictive risk scoring to remove high-risk contacts before they affect your brand.",
      tags: ["Compliance", "Security"],
      features: [
        "Continuous compliance monitoring",
        "Automated consent verification",
        "Predictive risk scoring",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },

    {
      title: "Patented QR Code Intelligence",
      image: "https://images.unsplash.com/photo-1552664688-cf412ec27db2?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-qrcode",
      hoverIcon: "fas fa-lock",
      frontIcon: "fas fa-qrcode",
      description:
        "World's most protected QR ecosystem secured by O'Hanlon Patents.",
      hoverDescription: "Transform physical engagement into digital intelligence with the world's most protected QR ecosystem, secured by O'Hanlon Patents. Every QR code generated is backed by a compliance engine that cross-references O'Hanlon patent standards.",
      tags: ["QR", "Patented"],
      features: [
        "Infringement-proof campaigns",
        "Scan pattern analysis",
        "The O'Hanlon Shield protection",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },

    {
      title: "Patent Infringement Analysis",
      image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1000&q=80",
      icon: "fas fa-search-plus",
      hoverIcon: "fas fa-balance-scale",
      frontIcon: "fas fa-search-plus",
      description:
        "AI identifies competitive advantages and protects your proprietary methodologies.",
      hoverDescription: "Leverage our unique patented technology to identify competitive advantages and protect your interests. Our AI identifies when competitors are utilizing your proprietary methodologies, providing you with the data needed to defend your market position.",
      tags: ["Patents", "Analysis"],
      features: [
        "Automated infringement detection",
        "Competitive advantage analysis",
        "Proprietary methodology protection",
      ],
      learnLink: "/services",
      demoLink: "/contact",
    },
  ];
  const features = [
    {
      icon: "fa-brain",
      title: "Patented Performance Algorithms",
      desc: "We leverage a unique, patented framework to continuously analyze and refine your campaigns. Unlike generic tools, our machine learning models are built on proprietary logic that competitors cannot replicate."
    },
    {
      icon: "fa-shield-alt",
      title: "Dynamic ROI Maximization",
      desc: "Our AI doesn't just track results; it predicts and drives them. Using O'Hanlon-backed predictive modeling, the system identifies the highest-yield pathways in real-time to ensure every marketing dollar is optimized for peak performance."
    },
    {
      icon: "fa-chart-line",
      title: "Autonomous Campaign Self-Healing",
      desc: "If an optimization branch underperforms, our patented logic instantly triggers alternative 'Best-Next-Action' workflows, maintaining your ROI without manual intervention."
    },
    {
      icon: "fa-gears",
      title: "Proprietary Intelligence Shield",
      desc: "By choosing a platform powered by O'Hanlon Patents, you are investing in a marketing ecosystem where your optimization techniques are protected from unauthorized duplication, securing your long-term competitive edge."
    },
    {
      icon: "fa-chart-pie",
      title: 'Patented "Scan-to-ROI" Attribution',
      desc: "Accurately track the entire customer journey from a physical scan or click to a completed sale. Our patented tracking logic identifies high-value touchpoints that generic systems miss."
    },
    {
      icon: "fa-layer-group",
      title: "Proprietary Predictive Performance",
      desc: "Using patented predictive algorithms, our AI simulates campaign outcomes in real-time, allowing you to optimize your strategy before significant spend is committed."
    }
  ];
  const pricingPlans = [
    {
      title: "Professional",
      subtitle: "For growing businesses",
      price: "499",
      type: "Monthly",
      features: [
        "Up to 50,000 messages/month",
        "Basic patent protection",
        "Standard compliance monitoring",
        "Email support",
        "QR code campaigns"
      ],
      button: "Get Started",
      popular: false
    },
    {
      title: "Enterprise",
      subtitle: "Our most comprehensive plan",
      price: "999",
      type: "Monthly",
      features: [
        "Up to 200,000 messages/month",
        "Full patent protection suite",
        "Advanced compliance AI",
        "Priority phone & email support",
        "Infringement detection",
        "Dedicated account manager"
      ],
      button: "Get Started",
      popular: true
    },
    {
      title: "Custom",
      subtitle: "For large organizations",
      price: "Custom",
      type: "",
      features: [
        "Unlimited messages",
        "Complete patent portfolio access",
        "White-label solutions",
        "24/7 dedicated support",
        "API access & custom integration",
        "Legal consultation included"
      ],
      button: "Contact Sales",
      popular: false
    }
  ];

  const additionalCards = [
    {
      icon: "fa-sync-alt",
      title: "Patented Cross-Channel Synchronization",
      desc: "Move beyond fragmented messaging. Our O'Hanlon-patented logic ensures that every touchpoint is perfectly synchronized in real-time."
    },
    {
      icon: "fa-crosshairs",
      title: "Proprietary Unified Attribution",
      desc: "Gain a crystal-clear view of your ROI. Using patented tracking algorithms, we attribute conversions across multiple channels."
    },
    {
      icon: "fa-bolt",
      title: "Behavior-Triggered Multi-Channel Flows",
      desc: "Our AI uses patented behavioral triggers to deploy the right message on the right channel at the perfect moment."
    },
    {
      icon: "fa-shield-alt",
      title: "The O'Hanlon Innovation Shield",
      desc: "Ensure your integrated marketing 'playbooks' remain your exclusive intellectual property, protected from unauthorized duplication."
    }
  ];

  const analyticsPoints = [
    {
      icon: "fa-chart-bar",
      title: "O'Hanlon-Verified Behavioral Insights",
      desc: "Capture deep-dive analytics on user behavior. This patented data-capture methodology provides a level of forensic detail that is exclusive to our platform.",
      badge: "AI-POWERED"
    },
    {
      icon: "fa-check-circle",
      title: "Real-Time ROI Verification",
      desc: "Access an instant, iron-clad view of your campaign's financial impact. Our patented ROI engine provides a 'Source of Truth' that is legally secure and mathematically precise.",
      badge: "REAL-TIME"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Header />
      {/* HERO SECTION */}
      <section className="hero-video section-container">
        <video
          id="hero-video"
          autoPlay
          muted={muted}
          loop
          playsInline
        >
          <source src={jeevesIpVideo} type="video/mp4" />
        </video>

        <div className="hero-overlay">
          <h1 style={{fontSize: "2.5rem"}}>Ask Jeeves IP: Intellectual Property Compliance & Patent Licensing Hub</h1>
          <p>Transforming enterprise operations and addressing unauthorized patent infringement activities to elevate businesses.</p>

          <Link to={"/services"}
            className="hero-btn"
          >
            Explore Strategic IP Integration & Licensing
          </Link>

          <button
            className="sound-btn"
            onClick={() => setMuted(!muted)}
          >
            {muted ? "🔇" : "🔊"}
          </button>
        </div>
      </section>

      {/* SERVICES INTRO */}
      <section className="services-intro section-container">
        <div className="content-container">
          <span className="section-badge">The Ask Jeeves IP Advantage</span>
          <h2>
            Unlock A Powerful IP <span className="highlight">Marketing Tool</span>
          </h2>
          <p>
            Elevate your mobile marketing to the next level with Unlock A
            Powerful IP Marketing Tools by Ask-Jeeves, the pinnacle of modern
            enterprise SaaS.Built upon the Seven Pillars of Excellence and our proprietary, patented technology, our platform delivers the ultimate SMS experience for the modern enterprise. From ironclad TCPA-compliant messaging to instantaneous, real-time content delivery, we provide the powerful tools you need to engage your audience on the platform they use most. Experience the gold standard in mobile communication and transform your brand with Ask-Jeeves.
          </p>
          <p>
            Our suite doesn't just send messages; it orchestrates high-performance mobile journeys backed by the legal and technical precision of O'Hanlon Patents.
          </p>
        </div>

        <div className="ai-services-wrapper">
          <div className="ai-services-grid">
            {services.map((service, index) => (

              <div className="ai-service-card" key={index}>

                <div className="card-front">
                  <div className="ai-service-image">
                    <img src={service.image} alt={service.title} />
                    <div className="ai-service-gradient"></div>

                    <div className="ai-service-icon">
                      <i className={service.frontIcon}></i>
                    </div>
                  </div>

                  <div className="ai-service-content">
                    <div>
                      <h3 className="ai-service-title">{service.title}</h3>

                      <p className="ai-service-description">
                        {service.description}
                      </p>
                    </div>

                    <div className="ai-service-footer">

                      <div className="ai-service-tags">
                        {service.tags.map((tag, i) => (
                          <span className="ai-service-tag" key={i}>
                            {tag}
                          </span>
                        ))}
                      </div>

                      <div className="ai-service-arrow">
                        <i className="fas fa-arrow-right"></i>
                      </div>

                    </div>
                  </div>
                </div>


                <div className="card-hover">

                  <div className="ai-hover-header">
                    <h3 className="ai-hover-title">{service.title}</h3>

                    <div className="ai-hover-icon">
                      <i className={service.hoverIcon}></i>
                    </div>
                  </div>

                  <p className="ai-hover-description">
                    {service.hoverDescription}
                  </p>

                  <div className="ai-hover-features">

                    {service.features.map((feature, i) => (
                      <div className="ais-feature" key={i}>
                        <i className="fas fa-check-circle"></i>
                        <span>{feature}</span>
                      </div>
                    ))}

                  </div>

                  <div className="ai-hover-actions">

                    <Link to={service.learnLink}>
                      <button className="ai-hover-btn ai-btn-primary">
                        Learn More
                      </button>
                    </Link>

                    <Link to={service.demoLink}>
                      <button className="ai-hover-btn ai-btn-secondary">
                        Demo
                      </button>
                    </Link>

                  </div>

                </div>

              </div>

            ))}
          </div>
        </div>
      </section>
      <section className="about-us section-container">
        <div className="content-container">
          <div className="abouts-content">
            <span className="section-badge">
              Why Choose Our AI Platform?
            </span>

            <h2>
              The New Standard for
              <span className="highlight">
                Patent Protection
              </span>
            </h2>
            <p>
              In an increasingly competitive digital landscape, your enterprise
              needs more than just a service provider—it needs a protected
              technological edge. Our platform is built on a foundation of
              exclusive, proprietary innovation that ensures your marketing
              strategies remain unique, defensible, and high-performing.
            </p>

            <p>
              We are redefining the landscape of intellectual property by
              fusing elite legal expertise with proprietary AI innovation.
              Our platform doesn't just monitor patents; it establishes a
              new global benchmark for how IP is protected, optimized,
              and defended.
            </p>
          </div>

          <div className="about-visual">

            <img
              src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="AI Mobile Marketing"
            />

            <div className="stat stat-top">
              <h3>Exclusive</h3>
              <span>Patent Protection</span>
            </div>

            <div className="stat stat-bottom">
              <h3>Defensible</h3>
              <span>Competitive Advantage</span>
            </div>

          </div>

        </div>
      </section>
      <section className="split-banner section-container">
        <div className="content-container">

          <div className="split-content">
            <span className="section-badge">
              Secured by O'Hanlon Patents
            </span>

            <h2>
              Advanced TCPA Compliance AI
              <br />
              <span className="highlight">
                "Zero-Error" Protection
              </span>
            </h2>

            <p>
              Protect your enterprise from the significant legal risks of
              non-compliance with a "Zero-Error" system. Our AI-driven
              platform uses proprietary methodologies, protected by
              O'Hanlon Patents, to provide real-time oversight and
              automated guardrails for every campaign.
            </p>

            <Link to={"/contact"}
              className="split-btn"
            >
              Get Protected Today
            </Link>
          </div>

          <div className="split-image">
            <img
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
              alt="Mobile Marketing Banner"
            />
          </div>

        </div>
      </section>

      {/* FEATURES */}
      <section className="features section-container">
        <div className="content-container">

          <div className="section-header">
            <span className="section-badge">
              Proprietary Technology Framework
            </span>

            <h2>
              AI-Powered Optimization:
              <br />
              <span className="highlight">
                The O'Hanlon Patented Engine
              </span>
            </h2>

            <p>
              Our platform goes beyond standard automation by using an exclusive
              suite of machine-learning algorithms protected by O'Hanlon Patents.
              This ensures that your optimization strategy is not only effective
              but also proprietary and legally defensible.
            </p>
          </div>

          <div className="features-grid">

            {features.map((feature, index) => (

              <div className="feature-box" key={index}>

                <i className={`fa-solid ${feature.icon}`}></i>

                <h3>{feature.title}</h3>

                <p>{feature.desc}</p>

              </div>

            ))}

          </div>

        </div>
      </section>


      {/* STATS */}
      <section className="stats-wrapper section-container">
        <div className="stats-inner">
          <div className="stats-cards">
            <div className="stat-box">
              <h3>50+</h3>
              <p>Patents Granted</p>
            </div>

            <div className="stat-box">
              <h3>10K+</h3>
              <p>Businesses Protected</p>
            </div>

            <div className="stat-box">
              <h3>100%</h3>
              <p>TCPA Compliance Rate</p>
            </div>

            <div className="stat-box">
              <h3>5B+</h3>
              <p>Protected Messages</p>
            </div>
          </div>
          <div class="trusted-content">
            <h2>Trusted by Industry Leaders</h2>
            <p>
              Our proven track record and innovative technology have made us the preferred choice for businesses looking to transform their mobile marketing strategies with legally-defensible, high-performance solutions.
            </p>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="review-section section-container">
        <div className="content-container">
          <div className="section-header">
            <span className="section-badge">Enterprise Testimonials</span>
            <h2>
              What Our <span className="highlight">Clients Say</span>
            </h2>
          </div>

          <div className="review-slider">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`review-slide ${index === currentSlide ? "active" : ""
                  }`}
              >
                <div className="review-left">
                  <img src={slide.img} alt="Client" />

                  <p className="review-text">{slide.text}</p>

                  <hr />

                  <h4>{slide.name}</h4>
                  <span>{slide.role}</span>
                </div>

                <div className="review-right">
                  <img src={slide.companyImg} alt="Company" />
                </div>
              </div>
            ))}

            <div className="review-dots">
              {slides.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentSlide ? "active" : ""
                    }`}
                  onClick={() => setCurrentSlide(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-section section-container">
        <div className="content-container">

          <div className="section-header">
            <span className="section-badge">Protected Pricing</span>
            <h2>
              Enterprise-
              <span className="highlight">Grade Protection</span>
            </h2>
            <p>
              Choose the plan that fits your business needs with patented
              protection and premium support included.
            </p>
          </div>

          <div className="pricing-grid">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`pricing-card ${plan.popular ? "popular" : ""}`}
              >

                {plan.popular && (
                  <span className="popular-tag">MOST PROTECTED</span>
                )}

                <div className="pricing-header">
                  {plan.title}
                  <small>{plan.subtitle}</small>
                </div>

                <div className={`pricing-price ${plan.price === "Custom" ? "custom" : ""}`}>
                  {plan.price !== "Custom" && <span>$</span>}
                  {plan.price}
                  {plan.type && <small>{plan.type}</small>}
                </div>

                <ul className="pricing-features">
                  {plan.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>

                <Link to={"/contact"}
                  className="pricing-btn"
                >
                  {plan.button}
                </Link>

              </div>
            ))}
          </div>

        </div>
      </section>
      <section className="additional-content section-container">
        <div className="content-container">

          <div className="section-header">
            <span className="section-badge">Complete Platform Overview</span>

            <h2>
              Multi-Channel Integration
              <br />
              <span className="highlight">
                Secured by O'Hanlon Patents
              </span>
            </h2>

            <p>
              Experience enterprise-grade marketing automation with legally protected technology
            </p>
          </div>

          {/* Cards Grid */}
          <div className="additional-grid">
            {additionalCards.map((card, index) => (
              <div key={index} className="additional-card">

                <div className="card-icon">
                  <i className={`fas ${card.icon}`}></i>
                </div>

                <div className="card-content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>

                <div className="card-footer">
                  <span className="patent-tag">PATENT PROTECTED</span>
                </div>

              </div>
            ))}
          </div>

          {/* Analytics Section */}
          <div className="analytics-section">

            <div className="analytics-header">
              <h3 className="analytics-title">
                Real-Time Analytics AI:
                <span className="highlight">
                  Secured by O'Hanlon Patents
                </span>
              </h3>

              <p className="analytics-subtitle">
                Gain a decisive competitive advantage with our advanced analytics dashboard.
                Our platform uses proprietary methodologies to deliver instant, actionable insights.
              </p>
            </div>

            <div className="info-points">
              {analyticsPoints.map((point, index) => (
                <div key={index} className="info-point">

                  <div className="info-icon">
                    <i className={`fas ${point.icon}`}></i>
                  </div>

                  <div className="info-content">
                    <h4>{point.title}</h4>
                    <p>{point.desc}</p>
                  </div>

                  <div className="info-badge">
                    <span className="badge">{point.badge}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEWSLETTER */}
      <section className="newsletter-section section-container">
        <div className="newsletter-overlay">
          <div className="newsletter-content">
            <h2>Ready to Revolutionize Your Mobile Marketing?</h2>
            <p>
              Join thousands of forward-thinking businesses using Ask Jeeves IP to drive engagement, generate qualified leads, and increase revenue with patented, high-performance SMS marketing secured by O'Hanlon Patents.
            </p>
            <form className="newsletters-form">
              <input
                type="email"
                placeholder="Enter your email address"
                required
              />
              <button type="submit">Start Free Trial</button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default LaunchingSoon;